import { gql } from '@apollo/client'

export const CREATE_LEGAL_DOCUMENT = gql`
  mutation CreateLegalDocument($input: CreateLegalDocumentDtoInput!) {
    createLegalDocument(input: $input) {
      id
      name
      versionMajor
      versionMinor
      versionPatch
      documentType
      content
      isActive
      originalFileUri
      originalFileName
      createdAt
      createdBy
    }
  }
`

export const ACCEPT_LEGAL_DOCUMENT = gql`
  mutation AcceptLegalDocument(
    $legalDocumentId: Long!
  ) {
    acceptLegalDocument(
      legalDocumentId: $legalDocumentId
    ) {
      id
      driverId
      legalDocumentId
      legalDocument {
        documentType
      }
      createdAt
    }
  }
`
